// Separado de EventosClient.tsx (que es "use client") a propósito: page.tsx
// (Server Component) necesita este valor también, e importar un export
// plano desde un módulo "use client" hacia un Server Component es un cruce
// de límites poco común que se sospecha causó un fallo silencioso en el
// bundling de Netlify (funcionaba en build local, no en producción — ver
// commit que agregó este archivo). Un módulo neutral, sin directiva, evita
// el problema de raíz en vez de solo mitigarlo.
export const PAGE_SIZE = 12;
